<template>
	<el-drawer
		:append-to-body="appendToBody"
		@close="$emit('close')"
		:visible="isVisible"
		direction="rtl"
		:size="width"
	>
		<div class="modalBody">
			<slot />
		</div>
	</el-drawer>
</template>

<script>
export default {
	props: {
		appendToBody: Boolean,
		visible: Boolean,
		width: {
			type: String,
			default() {
				return "400px";
			},
		},
	},
	computed: {
		isVisible() {
			return this.visible;
		},
	},
};
</script>

<style scoped>
.modalBody {
	padding-left: 40px;
	padding-right: 40px;
}
</style>
